import React from "react";
import styled from 'styled-components';
import PostListItem from "./PostListItem";
import Button from "../ui/Button";

 
const Container = styled.div`
 
`;
const ButtonWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
 
`;
const Wrapper = styled.div`
 
  display: grid;
 
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
  gap: 20px;
 
  border-radius: 18px;
 

 @media (max-width: 1200px) { 
    grid-template-columns: 1fr;
    justify-items: center;
}
   

 
 `;
function PostList(props) {
    const { posts, onClick } = props;

    return (
         <Container>
        <Wrapper id="menu">
            {posts.map((post, index) =>{
                return (
                    
                    <PostListItem 
                        key={post.id}
                        post={post}
                        onClick={()=> {
                            onClick(post);
                        }}
                    />
                );
            }
            )}
            
        </Wrapper>
        <ButtonWrapper>
              <Button title="See More Dishes" style={{  marginTop: '0px'}}/>
            </ButtonWrapper>
        </Container>
    );
}

export default PostList;